module.exports = __webpack_public_path__ + "img/bonk.c736a248.svg";